import { Component, Input } from '@angular/core';

@Component({
  selector: 'questionarieControl',
  templateUrl: './questionarie-control.component.html',
  styleUrls: ['./questionarie-control.component.scss']
})
export class QuestionarieControlComponent {
  @Input() question;
  @Input() root = false;

  updateChildNode(node) {
    if (!node.children.length) {
      return;
    }
    for (const children of node?.children) {
      children.answerId = null;
      children.answerText = null;
      console.log(node)
      this.updateChildNode(children);
    }
  }
}
